export const isEmail = (email: string) => {
  const emailReg = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/
  return emailReg.test(email)
}

export const isPhone = (phone: string) => {
  const phoneReg = /^0\d{1,3}-\d{2,4}-\d{3,4}$/
  return phoneReg.test(phone)
}
